import { cn } from "@/lib/utils";

interface InlineBarProps {
  value: number;
  max: number;
  variant?: "accent" | "gold" | "primary";
  className?: string;
}

export function InlineBar({ value, max, variant = "accent", className }: InlineBarProps) {
  const pct = max > 0 ? Math.min((value / max) * 100, 100) : 0;
  return (
    <div className={cn("h-1.5 rounded-full bg-muted overflow-hidden flex-1", className)}>
      <div
        className={cn(
          "h-full rounded-full transition-[width] duration-500",
          variant === "accent" && "bg-accent",
          variant === "gold"   && "bg-gold",
          variant === "primary" && "bg-primary",
        )}
        style={{ width: `${pct}%` }}
      />
    </div>
  );
}
